import { render, staticRenderFns } from "./DiamondReport1920.vue?vue&type=template&id=1de88864&scoped=true"
import script from "./DiamondReport1920.vue?vue&type=script&lang=js"
export * from "./DiamondReport1920.vue?vue&type=script&lang=js"
import style0 from "./DiamondReport1920.vue?vue&type=style&index=0&id=1de88864&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de88864",
  null
  
)

export default component.exports